module.exports = __webpack_public_path__ + "img/oliverlist_booker_menu.e1ca0d4d.png";